import { render, staticRenderFns } from "./DialogEditName.vue?vue&type=template&id=66552a80"
import script from "./DialogEditName.vue?vue&type=script&lang=js"
export * from "./DialogEditName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports